'use client'

import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import { useTelegramBotAPI } from '../hooks/useTelegramBotAPI'
import { consumePendingDeepLink, rememberDeepLink } from '../lib/telegramDeepLink'

// When the Mini App opens via t.me/bot?start=dream_… (or fantasy_…),
// remember the destination and, once the user is authenticated, send them there.
export default function DeepLinkRedirect() {
  const { startParam, ready } = useTelegramBotAPI()
  const { isAuthenticated, isLoading } = useAuthContext()
  const navigate = useNavigate()
  const handled = useRef(false)

  useEffect(() => {
    if (!ready || !startParam) return
    rememberDeepLink(startParam)
  }, [ready, startParam])

  useEffect(() => {
    if (!ready || isLoading || !isAuthenticated || handled.current) return
    const dest = consumePendingDeepLink(startParam)
    if (!dest) return
    handled.current = true
    navigate(dest, { replace: true })
  }, [ready, isLoading, isAuthenticated, startParam, navigate])

  return null
}
